import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
} from "@angular/core";
import { SchedulerComponent } from "../scheduler/scheduler.component";
import { UI } from "../../services/ui.service";
import { UserService } from "../../domain/user-service";
import { PopoverService } from "../../services/popover-service";
import { NavigationItemModel } from "../common/sideNav/navigationItem.model";

@Component({
  selector: "evrideo-media-transcoder",
  templateUrl: "../scheduler/scheduler.component.html",
  styleUrls: ["../scheduler/scheduler.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaTranscoderComponent extends SchedulerComponent {
  constructor(
    ui: UI,
    element: ElementRef,
    userService: UserService,
    popoverService: PopoverService,
  ) {
    super(ui, element, userService, popoverService);
    this.showLibraryItemMenuButtons = true;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  async initNavigationItems(): Promise<void> {
    this.navigationItems.push(
      new NavigationItemModel("video", "video-icon", "media"),
    );
  }
}
